export { EditCourseMenu } from './component'
